import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import {css} from 'styled-components';
import ComponentStyles from 'styles/mixins/Component.styles';
import utils from 'helpers/utils';
import Box from 'components/atoms/Layout/Box/Box';
import {darken} from 'polished';

const StyledLegend = styled(Box)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--legend-rows': utils.isDefined(props.$rows) ? `${props.$rows}` : null
    };

    return utils.styleProps(attr, vars);
  })`
  display: flex;
  justify-content: center;

  &.Legend {
    &-isLoading {
      .Legend-list {
        pointer-events: none;
        .Icon {
          opacity: 0.2;
        }
      }
    }
    
    &-clickable {
      .Legend-list {
        .ListItem:hover {
          cursor: pointer;

          .Legend-item-title {
            .Span {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  
  .Legend {
    &-list {
      width: unset;
      padding: 0;

      ${props => utils.isDefined(props.$rows) ? css`
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: repeat(${props.$css.$var('--legend-rows', false)}, 1fr);
        gap: ${props.theme.spacing(1)} ${props.theme.spacing(3)};
      ` : css`
        display: flex;
        justify-content: space-between;
        gap: ${props.theme.spacing(1)};
        flex-wrap: wrap;
      `}

      .ListItem {
        width: 100%;
        overflow: hidden;
        padding: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${props => props.theme.layout('0.75sp')};

        &:has(.Legend-item-explanation) {
          align-items: flex-start;
          > .Icon, > .Avatar {
            margin-top: ${props => props.theme.spacing(1/8)};
          }
          .Legend-item-title {
            font-weight: 500;
          }
        }
        
        .Legend-item {
          &-content {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 100%;
            overflow: hidden;
          }
          
          &-title {
            width: 100%;
            display: inline-flex;
            align-items: center;
            white-space: nowrap;
            gap: ${props => props.theme.layout('0.5sp')};
            
            .Span {
              ${props => props.theme.font2Css('caption')};
              max-width: ${props => props.theme.layout(100)};
              text-overflow: ellipsis;
              overflow: hidden;
            }
            
            .Badge {
              margin-top: ${props => props.theme.layout(-1)};
            }
          }
          
          &-explanation {
            ${props => props.theme.font2Css('caption')};
          }
        }

        > .Icon {
          margin-top: -${props => props.theme.layout(2)};
          &.defaultColor {
            color: ${props => darken(0.5, props.theme.property('palette.divider'))};
          }
        }
        > .Avatar {
          &.defaultColor {
            color: ${props => props.theme.palette.getContrastText(darken(0.5, props.theme.property('palette.divider')))};
            background-color: ${props => darken(0.5, props.theme.property('palette.divider'))};
          }
        }
        &:not(.active) {
          > .Icon {
            color: ${props => props.theme.property('palette.divider')};
          }
          > .Avatar {
            color: ${props => props.theme.property('palette.text.disabled')};
            background-color: ${props => props.theme.property('palette.divider')};
          }

          .Legend-item {
            &-title {
              .MuiBadge-badge {
                color: ${props => props.theme.property('palette.text.disabled')};
                background-color: ${props => props.theme.property('palette.divider')};
              }
            }
          }
        }
      }
    }
  }

  &.Legend-orientation-vertical {
    justify-content: flex-start;
    .Legend {
      &-list {
        row-gap: ${props => props.theme.layout('2sp')};
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledLegend.propTypes = {
  theme: PropTypes.object
};

export default StyledLegend;
